import { REACT_APP_FUNCTIONS_URL } from "../../constants/env";

const API_CONTACTS_URL = `${REACT_APP_FUNCTIONS_URL}/api/contacts`;
const API_CONTACTS_ERROR = "Une erreur est survenue, veuillez réessayer ultérieurement.";

const create = async (params) => {
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params)
  };

  return fetch(API_CONTACTS_URL, options)
    .then(res => {
      if (!res.ok) {
        return { error: API_CONTACTS_ERROR };
      } else {
        return {};
      }
    })
    .catch(error => {
      return { error: API_CONTACTS_ERROR };
    });
}

export default {
  create
}



// WEBPACK FOOTER //
// ./src/services/api/contacts.js